module.exports = __webpack_public_path__ + "images/customer-management/custmgmt_c.png";